import { Button, Menu } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconEdit, IconOutbound } from '@tabler/icons-react';
import Link from 'next/link';
import { useProjectId } from '~/hooks/context/useProjectId';
import { openViaForm } from '~/logic/url/open-via-form';
import { api } from '~/trpc-extra/api';
import { SplitButton } from '../common/SplitButton';

export function EditTestButton({ testContentId }: { testContentId: string }) {
  const projectId = useProjectId();

  const { data: testContent } = api.testContent.get.useQuery(
    { id: testContentId },
    { refetchOnMount: false, refetchOnWindowFocus: false, enabled: !!testContentId },
  );
  const { data: drafts = [] } = api.testDraft.listByTestId.useQuery(
    { testId: testContent?.test.id || '' },
    { enabled: !!testContent?.test.id },
  );

  const { mutate: createDraftForTest, isPending: isCreatingDraft } = api.testContent.fork.useMutation({
    onMutate: () => {
      notifications.show({ message: 'Creating a new draft copy...', color: 'gray' });
    },
    onSuccess: async (testDraft) => {
      openViaForm(`/project/${projectId}/testDraft/${testDraft.id}?fromTest=true`, '_blank');
    },
    onError: (e) => {
      console.error(e);
      notifications.show({ message: 'Error start editing', color: 'red' });
    },
  });

  return drafts.length > 0 ?
      <SplitButton
        mainTooltip="Create a new draft"
        menuTooltip="Existing drafts"
        buttonChildren="Edit Test"
        menuChildren={
          <>
            {drafts.map((d) => (
              <Menu.Item
                key={d.id}
                component={Link}
                href={`/project/${projectId}/testDraft/${d.id}?fromTest=true`}
                leftSection={<IconOutbound size={18} />}
              >
                {d.test.name || 'Untitled Draft'} - Updated at: ${new Date(d.updatedAt).toLocaleString()}
              </Menu.Item>
            ))}
          </>
        }
        buttonProps={{
          onClick: () => createDraftForTest({ testContentId }),
          loading: isCreatingDraft,
          leftSection: <IconEdit size={18} />,
        }}
      />
    : <Button onClick={() => createDraftForTest({ testContentId })}>Edit Test</Button>;
}
